import styled from "styled-components";

export const StyledEmojiList = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
